import React from 'react';
import { useNotifications } from '../../context/NotificationContext';
import './styles/Notifications.css';

const NotificationItem = ({ notification, onClose }) => {
  const { markAsRead } = useNotifications();

  const handleClick = async () => {
    // Mark as read if unread
    if (!notification.isRead) {
      await markAsRead(notification.id);
    }
    
    // Close dropdown
    onClose();
    
    // Optional: Navigate to relevant page based on notification type
    // handleNotificationClick(notification);
  };

  const getNotificationIcon = (type) => {
    switch (type) {
      case 'profile_update':
        return 'fas fa-user';
      case 'verification_pending':
        return 'fas fa-clock';
      case 'verification_approved':
        return 'fas fa-check-circle';
      case 'verification_rejected':
        return 'fas fa-times-circle';
      case 'reference_request':
        return 'fas fa-users';
      case 'system_alert':
        return 'fas fa-exclamation-triangle';
      default:
        return 'fas fa-bell';
    }
  };

  const getNotificationColor = (type) => {
    switch (type) {
      case 'verification_approved':
        return 'success';
      case 'verification_rejected':
        return 'error';
      case 'system_alert':
        return 'warning';
      default:
        return 'info';
    }
  };

  const formatTimestamp = (timestamp) => {
    const date = new Date(timestamp);
    const now = new Date();
    const diffInHours = (now - date) / (1000 * 60 * 60);

    if (diffInHours < 1) {
      return 'Just now';
    } else if (diffInHours < 24) {
      return `${Math.floor(diffInHours)}h ago`;
    } else if (diffInHours < 24 * 7) {
      return `${Math.floor(diffInHours / 24)}d ago`;
    } else {
      return date.toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric'
      });
    }
  };

  return (
    <div 
      className={`notification-item ${!notification.isRead ? 'unread' : ''}`}
      onClick={handleClick}
    >
      <div className={`notification-icon ${getNotificationColor(notification.type)}`}>
        <i className={getNotificationIcon(notification.type)}></i>
      </div>
      
      <div className="notification-content">
        {notification.title && (
          <div className="notification-title">
            {notification.title}
          </div>
        )}
        <div className="notification-message">
          {notification.message}
        </div>
        <div className="notification-time">
          {formatTimestamp(notification.createdAt)}
        </div>
      </div>

      {!notification.isRead && (
        <div className="notification-unread-indicator"></div>
      )}
    </div>
  );
};

export default NotificationItem;
